import { AdminResourceFilterStatusEnum } from 'lib/types';
import { useAuth } from './useAuth';

/**
 * ログイン中アドミンの `resourceFilterStatus` に基づく操作可否を導出する
 * ロール権限とは別軸の制限。`unrestricted` 以外 (kenes_only / construction_only) は
 * 作成系操作と ProjectGroup / ClientUser 全般を不可とする。
 * ※ この 2 ステータスは UI の出し分けに関しては同一挙動なので isRestricted 1 本で導出する。
 */
function useResourceFilter() {
  const { profile } = useAuth();
  const status = profile?.resourceFilterStatus ?? AdminResourceFilterStatusEnum.unrestricted;
  const isRestricted = status !== AdminResourceFilterStatusEnum.unrestricted;

  return {
    status,
    isRestricted,
    canCreateLocation: !isRestricted,
    canCreateProject: !isRestricted,
    canAccessProjectGroup: !isRestricted,
    canAccessClientUser: !isRestricted,
  };
}

export { useResourceFilter };
